import React, { useContext } from 'react';

import CallToAction from 'components/CallToAction';
import { useCallToActionQuery } from 'hooks/useCallToActionQuery';
import useLiveData from 'hooks/useLiveData';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const CallToActionProvider = ({ children, staticData, id }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useCallToActionQuery();
	const shouldLimitLiveDataByStaticIds = !staticData;
	const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
	const callToActionEdges = effectiveStaticData?.allCallToAction?.edges || effectiveStaticData?.allSmartTagsCallToAction?.edges || [];
	const callToActionNodes = callToActionEdges.map(({ node }) => node).filter(item => !id || item.id === id);

	const {
		response: callToActionResponse,
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'CallToAction',
		method: 'all',
		graphqlKey: 'allSmartTagsCallToAction',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Audience',
			...(shouldLimitLiveDataByStaticIds && callToActionNodes.length > 0 ? {
				id: callToActionNodes.map((n) => n.id).join(','),
			} : {}),
			...(!!id ? { id } : {}),
		},
		staticData: effectiveStaticData,
	});

	const datum = callToActionResponse.data.filter((item) => !id || item.id === id)[0];
	if (!datum)return null;
	if (!matchAudience(datum?.Audience))return null;

	return (
		<CallToAction {...datum} matchAudience={matchAudience} />
	);
};

export default CallToActionProvider;